// eslint-disable-next-line
const appConfig = {};

appConfig.REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://apipreprod.thesieve.media/api/v1/";
appConfig.REACT_APP_API_KEY =
  appConfig.REACT_APP_API_KEY || process.env.REACT_APP_API_KEY || "";

export default appConfig;
// "https://sieveapidev.appskeeper.in/api/v1/"